
































import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import {
  computed,
  defineComponent,
  ref,
  defineVue3AsyncComponent
} from '~/utils/nuxt3-migration'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import { useNamespacedStore } from '~/compositions/store'
import { ciEdit } from '~/icons/source/solid/edit'

export default defineComponent({
  components: {
    CCard,
    CClassifiedNotes: defineVue3AsyncComponent(() =>
      import(
        '~/components/shared/configurable/classified/note/CClassifiedNotes.vue'
      )
    )
  },
  props: {
    classified: {
      type: Object,
      required: true,
      default: null
    }
  },
  setup() {
    const {
      state: classifiedViewState,
      getters: classifiedViewGetters
    } = useNamespacedStore<ClassifiedViewState>(CLASSIFIED_VIEW_NS)
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)

    const notesOpen = ref(false)
    const notesLoaded = ref(false)
    const noteTemplateRef = ref<any>(null)

    const isPlotClassified = computed(() =>
      classifiedViewGetters('isPlotClassified')
    )

    const isAnon = computed(() => userGetters('isAnon'))

    const currentUser = computed(() => classifiedViewState.currentUser)

    function showNotes() {
      notesOpen.value = true
      if (noteTemplateRef.value) {
        noteTemplateRef.value.focusLines()
      }
    }

    function handleOpenNotes(status: boolean) {
      notesOpen.value = status
      notesLoaded.value = true
    }

    return {
      notesLoaded,
      notesOpen,
      isPlotClassified,
      noteTemplateRef,
      currentUser,
      isAnon,
      showNotes,
      handleOpenNotes,
      ciEdit
    }
  }
})
